import {Injectable} from "@angular/core";
import {AbstractSQLService} from "./AbstractSQLService";
import {Taxon} from "../../../domain/Taxon";

@Injectable()
export class TaxonSQLService extends AbstractSQLService<Taxon>{
    nomeTabela = "taxon"
  agenciavel = false
    regexAcentos = /[\u0300-\u036f]/g;
    regexNaoLetras = /[^a-zA-Z]/g;
    separadores = /[ ,;\-_]/;
    removeAcento(texto: string): string[]{
        const textos = texto.split(this.separadores)
        const palavras = textos.filter(palavra => palavra.trim() !== '')
        return palavras
            .map(texto => texto.normalize('NFD')
                .replace(this.regexAcentos, '')
                .replace(this.regexNaoLetras, '')
                .toUpperCase());
    }
}
